export const getParams = (): Record<string, string> => {
  const url = new URL(window.location.href);
  const params: Record<string, string> = {};

  url.searchParams.forEach((rawValue, key) => {
    const value = decodeURIComponent(rawValue.trim());
    if (value) {
      params[key] = value;
    }
  });

  return params;
};
